/**
 * useGlobals — module-level cached accessor for the navbar/footer globals.
 *
 * TODO: When the backend exposes a `/api/website-cms/globals` endpoint,
 * replace the seed import with a real fetch + cache. Until then, we read
 * directly from the static seed so the public site can render globals.
 */
import { useEffect, useState } from 'react';
import seed from './seed.json';

let cachedGlobals = null;

export function getCachedGlobals() {
  if (cachedGlobals) return cachedGlobals;
  cachedGlobals = seed.globals || null;
  return cachedGlobals;
}

export function useGlobals() {
  const [globals, setGlobals] = useState(() => getCachedGlobals());
  useEffect(() => {
    if (!globals) setGlobals(getCachedGlobals());
  }, [globals]);
  return globals;
}

export default useGlobals;
